import {
    AdumoService,
    AuthService,
    OrderService,
    MovieMetaService,
    MovieService,
    RegionService,
    ContactUsService
} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import moment from 'moment'
import badgeConfig from './badgeConfig'
import Vue from 'vue'

const TOTAL_VIP_MOVIES_REQUIREMENT = 15;
export default {
    name: 'profile',
    data() {

        return {
            disabled: false,
            loading: false,
            loggedInUser: {},
            related_movies: [],
            relatedMoviesLabel: '',
            profile: false,
            showBookings: false,
            pointStatement: false,
            showUserActivation: false,
            activationLoading: false,
            BookingHistory: [],
            months: Utils.MonthMeta(),
            h1Active: true,
            preferences: {
                place_query: null,
                selected_cinema: [],
                selected_genres: [],
                selected_experiences: []
            },
            place: null,
            regions: [],
            genres: [],
            experiences: [],
            cinemasNearBy: [],
            search: 'sandton',
            updateLoader: false,
            loadBookings: true,
            skBadges: badgeConfig,
            movies: [],
            rewards: null,
            tierMoviesToGo: TOTAL_VIP_MOVIES_REQUIREMENT,
            tierMoviesPercentage: 0,
            changedEmail: null,
            nextReward: 400,
            linkingSkClub: false,
            linkingSB: false,
            loadingDelete: false,
            toggleJoinDialog: false,
            toggleActivateDialog:false,
            termsChecked: false,
            loadingUser: false,
            subsClub: null,
            subsClubColour: "primary",
            subsClubInactiveColour: "grey",
            subsClubIcon: "free-movieticket",
            subsClubSecondaryIcon: null,
            subsClubData: null,
            subsClubRenewDate: null,
            limitedSubsCinemas: ["3001", "6121", "6451", "5801", "1691","1101", "4201", "4231", "1351", "5451", "6101"],
            unlimitedSubsCinemas: ["3001", "6121", "6451", "5801", "1691","1101", "4201", "4231", "1351", "5451", "6101"],
            showConfirmReplaceCard: false,
            managePayment: false,
            card: {cardHolder: null, cardNumber: null, expiryMonth: null, expiryYear: null, cvvNumber: null, debitOrderDay: null, amount: 0, WorkZipCode: null},
            years: [],
            months:[{name: "January", value: "1"},{name: "February", value: "2"},{name: "March", value: "3"},{name: "April", value: "4"},{name: "May", value: "5"},{name: "June", value: "6"},{name: "July", value: "7"},,{name: "August", value: "8"},{name: "September", value: "9"},{name: "October", value: "10"},{name: "November", value: "11"},{name: "December", value: "12"}],
            processingUpdatePayment: false,
            updatePaymentStatus: undefined,
            subsClubitems: undefined,
            signedUpSubsClubItem: undefined,
            TermUrl: undefined,
            cancelSubLoading: false,
            toggleCancelSubDialog: false,
            toggleCardUpdate: false,
            loadingUpdateCard: false,
            adumoCardUpdate: {
                PaReq: '',
                TermUrl: `${process.env.APILINK}/content/subscription?type=cardUpdateResponse`,
                MD: '',
                postURL: ''
            },
            canCancelSub: false,
            canCancelSubErrorMessage: ''
        }
    },

    methods: {
        setUser(){
            this.loadingUser = true
            return AuthService.user().then((user)=> {
                if(user != undefined && user != null) {
                    if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                        this.showUserActivation = true;
                    } else {
                        this.showUserActivation = false;
                    }

                    if (user.isGuest()) {
                        window.location.href = '/user/login'
                    } else {
                        this.loggedInUser = user;
                        this.loggedInUser.Password = null;
                        this.loggedInUser.OldPassword = null;
                        if (localStorage.getItem('firstTimeDashboard') == null) this.firstTimeUser(this.loggedInUser)
                        this.loadingUser = false

                    }
                }

                return this.loggedInUser;
            })
        },

        firstTimeUser(user) {
            var today = new Date();
            let isToday = user.CreatedDate.isSame(today)

            if (isToday) {
                sessionStorage.setItem('firstTimeDashboard', true)
                if (sessionStorage.getItem('firstTimeDashboard')) {
                    this.$toaster.show(
                        `<strong>Congratulations, ${this.loggedInUser.FirstName}!</strong><br> You�ve earned 200 points just for joining SK Club! You can now view and keep track of your points on your dashboard.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                    )
                }
            }
        },

        linkCard(card){
            console.warn('link card is deprecated')
            //     if (card.Type != 'sb') {
            //         this.linkingSkClub = true;
            //         this.loggedInUser.addCard(card.CardNumber, card.Type);
            //         this.loggedInUser.saveCards().then(()=> {
            //             this.loggedInUser.CardNumber = card.CardNumber;
            //             this.linkingSkClub = false;
            //         }, ()=> this.linkingSkClub = false);
            //     } else {
            //         this.linkingSB = true;
            //         this.loggedInUser.NationalID = card.NationalID;
            //         this.loggedInUser.save().then(()=> {
            //             this.linkingSB = false;
            //         }, ()=> {
            //             this.linkingSB = false;
            //             this.loggedInUser.NationalID = undefined;
            //         });
            //     }
        },

        linkSb(idNumber){
            if(this.loggedInUser != undefined) {
                this.linkingSB = true;
                this.loggedInUser.NationalID = idNumber;
                this.loggedInUser.StandardBankBenefit = true
                this.loggedInUser.save().then(()=> {
                    // console.log('finished saving');
                    this.linkingSB = false;
                }, ()=> {
                    // console.log('finished saving');
                    this.linkingSB = false;
                    this.loggedInUser.NationalID = undefined;
                    this.loggedInUser.StandardBankBenefit = false
                });
            }
        },

        linkSkClub(card){
            // if(!this.loggedInUser.MembershipActivated){
            //     this.toggleActivateDialog = true
            //     return;
            // }
            this.linkingSkClub = true;
            this.loggedInUser.addCard(card, 'skClub');
            this.loggedInUser.saveCards().then((d)=> {
                // console.log("response", d);
                this.loggedInUser.CardNumber = card;
                this.loggedInUser.MemberLevelId = 1;
                this.linkingSkClub = false;
            }, (e)=> {
                this.linkingSkClub = false
            });

        },

        checkSlClub(){
            // if(!this.loggedInUser.MembershipActivated){
            //     this.toggleActivateDialog = true
            //     return;
            // }
            this.toggleJoinDialog = true;
        },

        joinSkClub(){
            // if(!this.loggedInUser.MembershipActivated){
            //     this.toggleActivateDialog = true
            //     return;
            // }
            this.loadingDelete = true
            this.loggedInUser.MemberLevelId = 1;
            this.updateUser().then(()=> {
                this.loadingDelete = false
                window.location.reload();
            });
        },

        placeSelected: function (place) {
            this.place = place;
            this.getClosestCinema('cinemas/:latitude/:longitude')
        },

        getClosestCinema () {

            RegionService.getCinemasNearBy(this.place.latitude, this.place.longitude).then((cinemasNearBy)=> {

                cinemasNearBy.length = 5; //restrict number of results to 5;

                this.cinemasNearBy = cinemasNearBy;

            });

        },

        selectSavedGenre(genre) {
            let newGenres = []
            if (this.preferences.selected_genres.includes(genre.name)) {
                this.preferences.selected_genres.filter((arr)=> {
                    if (arr != genre.name) newGenres.push(arr)
                })
                this.preferences.selected_genres = newGenres
            } else {
                this.preferences.selected_genres.push(genre.name)
            }
        },

        selectGenre(genre, event) {
            let newGenres = []
            if (this.preferences.selected_genres.includes(genre.name)) {
                this.preferences.selected_genres.filter((arr)=> {
                    if (arr != genre.name) newGenres.push(arr)
                    else event.currentTarget.classList.remove('active')
                })
                this.preferences.selected_genres = newGenres
            } else {
                this.preferences.selected_genres.push(genre.name)
                event.currentTarget.classList.add('active')
            }

        },

        selectExperience(experience, event) {
            let newExp = []
            if (this.preferences.selected_experiences.includes(experience.name)) {
                this.preferences.selected_experiences.filter((arr)=> {
                    if (arr != experience.name) newExp.push(arr)
                    else event.currentTarget.classList.remove('active')
                })
                this.preferences.selected_experiences = newExp
            } else {
                this.preferences.selected_experiences.push(experience.name)
                event.currentTarget.classList.add('active')
            }

        },

        updateUser() {
            this.updateLoader = true
            return this.loggedInUser.save().then(()=> {
                this.updateLoader = false,
                    this.profile = false
                window.scroll({top: 0, left: 0})
            })
        },

        allBookings(currentTarget) {
            this.pointStatement = false
            this.showBookings = true
            window.scroll({top: currentTarget.offsetTop + 200, left: 0, behavior: 'smooth'})
        },

        togglePoints(currentTarget) {
            this.pointStatement = !this.pointStatement
            if (this.pointStatement) window.scroll({top: currentTarget.offsetTop + 200, left: 0, behavior: 'smooth'})
        },

        saveProfile() {
            var genreIds = []

            for (var g = 0; g < this.genres.length; g++) {
                for (var sg = 0; sg < this.preferences.selected_genres.length; sg++) {
                    if (this.genres[g].name == this.preferences.selected_genres[sg]) {
                        genreIds.push(this.genres[g].id)
                    }
                }
            }

            if (this.loggedInUser.Email != this.changedEmail) {
                AuthService.initiateEmailChange(this.changedEmail, this.loggedInUser.MemberId).then(
                    (result) => {
                        // console.log(result)
                    }
                )

            }

            this.loggedInUser.PreferredGenres = genreIds
            // this.loggedInUser.PreferredComplex = this.preferences.selected_cinema.id
            this.updateLoader = true

            AuthService.updateUser(this.loggedInUser).then(() => {

                this.updateLoader = false
                window.scroll({top: 0})
                this.$toaster.show('Thanks for the update! Your info has successfully been saved.',
                    this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                        top: true,
                        fullwidth: true,
                        timeout: 5000
                    }
                )
            })
        },

        getRelatedMovies(movies, user) {
            if (!user || user.isGuest() || user.PreferredGenres.length == 0) {
                return movies.data;
            }
            ;
            let filteredMovies = []
            movies.data.reduce((c, movie)=> {
                movie.genres.forEach((genre)=> {
                    user.PreferredGenres.forEach((prefGen)=> {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie)
                        }
                    })
                })
            })
            return filteredMovies
        },

        goToResetPassword() {
            this.$router.push("/user/password-reset/email");
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },

        sendWelcomeMailFan(user) {
            let formData = {
                "FirstName": user.FirstName,
                "LastName": user.LastName,
                "Email": user.Email,
                "CardNumber": user.CardNumber,
            }

            // console.log("sendWelcomeMailFan")
            return Promise.resolve(ContactUsService.sendWelcomeMailFan(formData)).then((data) => {
                // console.log(data)
                this.loggedInUser.ZipCode = "True";
                this.saveProfile()
            })
        },

        sendWelcomeMailMorvies(user) {
            let formData = {
                "FirstName": user.FirstName,
                "LastName": user.LastName,
                "Email": user.Email,
                "CardNumber": user.CardNumber,
            }

            // console.log("sendWelcomeMailMORvies")

            return Promise.resolve(ContactUsService.sendWelcomeMailMORvies(formData)).then((data) => {
                // console.log(data)
                this.loggedInUser.ZipCode = "True";
                this.saveProfile()
            })
        },

        resendVerification() {
            this.activationLoading = true;
            AuthService.resendActivation().then(()=> {
                this.$emit('change', true);
                this.showUserActivation = false;
                this.activationLoading = false;
            });
        },

        confirmReplaceCard() {
            this.showConfirmReplaceCard = true
        },

        replaceCard() {
            //console.log("replace card")
        },

        setDateData() {
            let today = new Date()

            let year = today.getFullYear()
            let yearEnd = year + 10

            for(let y = year; y <= yearEnd; y++) {
                this.years.push({year: y})
            }

            return this.years
        },

        updateCardSubscription() {
            this.loadingUpdateCard = true
            AdumoService.updateCardSubscription(this.loggedInUser.MemberId, this.card).then(result => {
                if(result.success == true) {
                    if(result.data.status == true) {
                        this.adumoCardUpdate.MD = result.data.response.acsMD
                        this.adumoCardUpdate.PaReq = result.data.response.acsPayload
                        this.adumoCardUpdate.postURL = result.data.response.acsUrl
                        Vue.nextTick(() => {
                            this.$refs.frmLaunchACS.$el.submit()
                            this.loadingUpdateCard = false
                        })
                    } else {
                        this.$toaster.show(
                            `Card details could not be updated, please try again or contact customer support.`,
                            this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                                top: true,
                                fullwidth: true,
                                timeout: 10000
                            }
                        )
                        this.loadingUpdateCard = false
                    }
                } else {
                    this.$toaster.show(
                        `Card details could not be updated, please try again or contact customer support.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                    )
                    this.loadingUpdateCard = false
                }
            })
        },

        prepareUpdateDetails() {
            this.card.WorkZipCode = this.loggedInUser.WorkZipCode
            Promise.resolve(OrderService.prepareSubsUpdateDetails(this.card)).then((result) => {
                if(result.data != undefined && result.data != null) {
                    //console.log('result.data',result.data.md)
                    let md_decoded = atob(result.data.md)
                    //console.log('md_decoded', md_decoded)
                    if(result.success == true) {
                        if(result.data.status == true) {
                            // lsItem.currentStepUrl = "/subscribe/3"
                            // lsItem.currentStep = 4
                            // lsItem.currentStepName = "make-payment"
                            // lsItem.nextStep = 5
                            // lsItem.nextStepName = "confirm-payment"
                            // lsItem.nextStepUrl = ""
                            // lsItem.psRef = md_decoded.reference
                            // lsItem.debitOrderDay = this.card.debitOrderDay
                            // window.localStorage.setItem('subsClub', JSON.stringify(lsItem));
                            document.getElementById('frmLaunchACS').action = result.data.lookup.acsUrl
                            document.getElementById('PaReq').value = result.data.lookup.payload
                            document.getElementById('TermUrl').value = this.TermUrl;
                            document.getElementById('MD').value = JSON.stringify(result.data.md);
                            document.getElementById('frmLaunchACS').submit()
                            // this.loadingPayment = false;
                        } else {
                            this.$toaster.show(
                                `Payment details could not be updated, please try again or contact customer support.`,
                                this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                                    top: true,
                                    fullwidth: true,
                                    timeout: 10000
                                }
                            )
                        }
                    } else {
                        this.$toaster.show(
                            `Payment details could not be updated, please try again or contact customer support.`,
                            this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                                top: true,
                                fullwidth: true,
                                timeout: 10000
                            }
                        )
                    }
                }
            })
        },

        updatePaymentDetails() {
            // console.log("updatePaymentDetails",this.card)
            this.processingUpdatePayment = true
            Promise.resolve(OrderService.updateSubsPaymentDetails(this.card)).then((result) => {
                // console.log("result", result)

                if(result.data.success) {
                    this.updatePaymentStatus = true
                    this.$toaster.show(
                        `Payment details updated successfully.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                    )

                    this.managePayment = false
                    window.scroll({top: 0, left: 0})
                } else {
                    this.$toaster.show(
                        `Payment details could not be updated, please try again or contact customer support.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                    )

                    window.scroll({top: 0, left: 0})
                }

                this.processingUpdatePayment = false

                // console.log("processingUpdatePayment", this.processingUpdatePayment)
                // console.log("updatePaymentStatus", this.updatePaymentStatus)
            });
        },

        getConcessionItems(concessionItems) {
            var items = []
            for(var k = 0; k < concessionItems.length; k++) {
                var item = concessionItems[k]
                item.Price = "R " + (concessionItems[k].PriceInCents / 100)
                item.Quantity = 1
                items[k] = item
            }

            return items
        },

        cancelSubscription(memberId) {
            this.cancelSubLoading = true
            AdumoService.cancelSubscription(memberId,this.loggedInUser.UserSessionId)
                .then(response => {
                    this.loggedInUser.MemberLevelId = 0;
                    const unLimitSub = this.loggedInUser.PreferenceList.indexOf(5)
                    const limitSub = this.loggedInUser.PreferenceList.indexOf(6);
                    let cancelledTrigger = false
                    if (unLimitSub !== -1) {
                        this.loggedInUser.PreferenceList.splice(unLimitSub, 1);
                        cancelledTrigger = true
                    } else if (limitSub !== -1) {
                        this.loggedInUser.PreferenceList.splice(limitSub, 1);
                        cancelledTrigger = true
                    }
                    if (cancelledTrigger) {
                        this.updateUser().then(()=> {
                            this.cancelSubLoading = false
                            window.localStorage.setItem('cancelledSub', JSON.stringify(response))
                            // window.location.reload();
                        });
                    }
                })
                .catch(error => {
                    this.cancelSubLoading = false
                    throw Error(error.error_string)
                })
            }
        },

    created() {
        this.loading = true;
        window.scrollTo(top)
        Promise.all([OrderService.getBookingHistory(), RegionService.getRegions(), MovieMetaService.getMovieMeta(), MovieService.getMovies(), AuthService.getRewards(), this.setUser(), OrderService.getTransactionHistory(), this.getSubsData(), OrderService.getConsessionsByCinemaId("standalone"), OrderService.getApiHttpDefaultBaseLinkUrl()]).then(([bookingHistory, regions, meta, movies, UserRewards, user,history, subs, standAloneConcessions, httpData])=> {
            
            this.setDateData();

            this.TermUrl = httpData + "/payment/manage/update-details";
            
            //

            for(let i = 0; i < standAloneConcessions.length; i++) {
                if(standAloneConcessions[i].Name == "Subs") {
                    this.subsClubitems = this.getConcessionItems(standAloneConcessions[i].ConcessionItems);
                }
            }


            // console.log("ZipCode", this.loggedInUser.ZipCode);
            // console.log("PreferenceList", this.loggedInUser.PreferenceList);
            if(this.loggedInUser != undefined && this.loggedInUser != null) {
                if(this.loggedInUser.ZipCode != undefined && this.loggedInUser.ZipCode != null) {
                    if(this.loggedInUser.ZipCode != "True") {
                        if(this.loggedInUser.CardNumber != undefined && this.loggedInUser.CardNumber != null) {
                            if(this.loggedInUser.PreferenceList != undefined && this.loggedInUser.PreferenceList != null) {
                                if(this.loggedInUser.PreferenceList.includes(5)) {
                                    this.sendWelcomeMailMorvies(this.loggedInUser);
                                }

                                if(this.loggedInUser.PreferenceList.includes(6)) {
                                    this.sendWelcomeMailFan(this.loggedInUser);
                                }
                            }

                        }
                    }
                }
            }

            // console.log("managepayment",this.$route.params.managepayment)
            if(this.$route.params.managepayment != undefined && this.$route.params.managepayment != null) {
                
                if(this.$route.params.managepayment == "success") {
                    this.updatePaymentStatus = true
                    this.$toaster.show(
                        `Payment details updated successfully.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                    )

                    this.managePayment = false
                    window.scroll({top: 0, left: 0})
                } else if(this.$route.params.managepayment == "failure"){
                    this.$toaster.show(
                        `Payment details could not be updated, please try again or contact customer support.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                        )
                        window.scroll({top: 0, left: 0})
                    }
            }

            if(this.subsClubitems != undefined) {
                for(let i =0; i < this.subsClubitems.length; i++) {
                    if(this.subsClubitems[i].Description == "Unlimited Subs") {
                        if(this.loggedInUser.PreferenceList != undefined && this.loggedInUser.PreferenceList != null) {
                            if(this.loggedInUser.PreferenceList.includes(5)) {
                                this.signedUpSubsClubItem = this.subsClubitems[i]
                            }
                        }
                    }

                    if(this.subsClubitems[i].Description == "Limited Subs") {
                        if(this.loggedInUser.PreferenceList != undefined && this.loggedInUser.PreferenceList != null) {
                            if(this.loggedInUser.PreferenceList.includes(6)) {
                                this.signedUpSubsClubItem = this.subsClubitems[i]
                            }
                        }
                    }
                }
            }
            
            if(this.signedUpSubsClubItem != undefined) {
                this.card.amount = this.signedUpSubsClubItem.PriceInCents/100;
            }
            
            let skClubReplaceCard = window.localStorage.getItem('skClubReplaceCard');
            if(skClubReplaceCard != undefined) {
                if(skClubReplaceCard) {
                    window.scroll({top: 0, left: 0})
                    this.$toaster.show(
                        `SK Club card has been replaced successfully.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                        )
                        window.localStorage.removeItem('skClubReplaceCard');
                    }
            }
            // console.log(skClubReplaceCard)
            
            //

            if(user == undefined) {
                location.reload()
            }

            if(this.loggedInUser.WorkZipCode != undefined && this.loggedInUser.WorkZipCode != null) {
                let subsClubData = this.loggedInUser.WorkZipCode.split("|")
                let dateString = subsClubData[10].replace(/-/g, '/')
                // console.log(dateString)
                let date = new Date(dateString)

                this.subsClubRenewDate = date
            }
            
            if(this.subsClub != null && this.subsClub != undefined) {
                if(this.loggedInUser != undefined && this.loggedInUser != null) {
                    if(this.loggedInUser.PreferenceList != undefined && this.loggedInUser.PreferenceList != null) {
                        if(!this.loggedInUser.PreferenceList.includes(5) && !this.loggedInUser.PreferenceList.includes(6)) {
                            //does not have a subsclub subscription so redirect to next step
                            this.$router.push("/subscribe/1")
                        } else {
                            window.localStorage.removeItem("subsClub")
                        }
                    }
                }
            }
            
            if (user.MembershipActivated && AuthService.firstLogin == true) {
                AuthService.firstLogin = false;
                this.$toaster.show('Welcome back! You are now signed in.', this.$breakpoints.xs ? {
                    fixed: true,
                    timeout: 5000
                } : {
                    top: true,
                    fullwidth: true,
                    timeout: 5000,
                    fixed: false
                })
            }

            // moved preffered cinema check into user since other pages will see the id if you haven't hit profile first
            // or the object if you have
            
            this.BookingHistory = bookingHistory;
            this.regions = regions.data;
            this.genres = meta.genres
            this.experiences = meta.experiences
            this.changedEmail = this.loggedInUser.Email;
            
            // console.log("user", user)

            if(user.PreferredGenres == undefined) {
                location.reload();
            }

            for (var g = 0; g < this.genres.length; g++) {
                if (user.PreferredGenres.includes(parseInt(this.genres[g].id))) {
                    this.selectSavedGenre(this.genres[g]);
                }
                this.BookingHistory = bookingHistory;
                this.regions = regions.data;
                this.genres = meta.genres
                this.experiences = meta.experiences
                this.changedEmail = this.loggedInUser.Email
                for (var g = 0; g < this.genres.length; g++) {
                    if (user.PreferredGenres.includes(parseInt(this.genres[g].id))) {
                        this.selectSavedGenre(this.genres[g]);
                    }
                }

                if (user.PreferredGenres.length > 0) {
                    this.related_movies = this.getRelatedMovies(movies, user)
                    this.relatedMoviesLabel = `Movies we think you'll enjoy`
                } else {
                    this.related_movies = movies.data;
                    this.relatedMoviesLabel = 'Movies now showing'
                }
            }

            let rewards = UserRewards.ConcessionList.concat(UserRewards.TicketTypeList);
            this.rewards = rewards
            // console.log(rewards)
            for (var i = 0; i < rewards.length; i++) {
                var reward = rewards[i];
                for (var j = 0; j < this.skBadges.length; j++) {
                    var badge = this.skBadges[j];
                    if (badge.test(reward)) {
                        badge.active = true;
                        badge.alt = reward.NameAlt !== "" ? reward.NameAlt : undefined;
                        this.nextReward = badge.nextPoints !== undefined ? badge.nextPoints : this.nextReward;
                    }

                }
            }


            // .then((history)=> {
                
                let year = new Date().getFullYear(),
                num_movies_watched = history.filter((h)=>h.year == year && h.MovieId).length;
                this.tierMoviesToGo = TOTAL_VIP_MOVIES_REQUIREMENT - num_movies_watched;
                this.tierMoviesPercentage = (num_movies_watched / TOTAL_VIP_MOVIES_REQUIREMENT) * 100;
                
                
            // check points expiry:
            for (var i = 0; i < this.loggedInUser.ExpiryPointsList.length; i++) {
                var point = this.loggedInUser.ExpiryPointsList[i];
                if (point.ExpiringSoon === true) {
                    this.$toaster.show(`<strong>Don't let your points go to waste!</strong><br> <strong>${point.PointsExpiring}</strong> Points will Expire on ${point.friendlyExpiryDate} `, {
                        dismissable: true,
                        fullwidth:true,
                        // top:true,
                        timeout: 0
                    }, document.body.querySelector('.points-display'));
                    break;
                }
            }
            
            if (this.$route.query.cardUpdate) {
                if (this.$route.query.cardUpdate == 'success') {
                    AdumoService.updateCardSubscriptionTokens(this.loggedInUser.MemberId)
                        .then(() => {
                            this.$toaster.show(
                                `Card details have been updated successfully.`,
                                this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                                    top: true,
                                    fullwidth: true,
                                    timeout: 10000
                                }
                                )
                                this.$router.replace({path: this.$route.path})
                            })
                }
                if (this.$route.query.cardUpdate == 'failed') {
                    this.$toaster.show(
                        `Card details could not be updated, please try again or contact customer support.`,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                        }
                        )
                    }
                }
                
                AdumoService.checkCancelSubscription(this.loggedInUser.MemberId)
                            .then((res) => {
                                this.canCancelSub = res.data.success
                                if (!this.canCancelSub) this.canCancelSubErrorMessage = res.data.error
                            })
                            .catch(error => {
                                throw Error(error.error_string)
                            })
                
                this.loading = false;
                
                if (window.localStorage.getItem('cancelledSub')) {
                    const cancelledSubStorage = window.localStorage.getItem('cancelledSub')
                    const parseCancelledSubStorage = JSON.parse(cancelledSubStorage)
                    window.localStorage.removeItem('cancelledSub')
                    this.$toaster.show(
                        parseCancelledSubStorage.data.success ? 'Subscription has been cancelled' : parseCancelledSubStorage.data.error,
                        this.$breakpoints.xs ? {fixed: true, timeout: 5000} : {
                            top: true,
                            fullwidth: true,
                            timeout: 10000
                    }
                    )
            }
            
            Vue.nextTick(()=>{
                if (this.$route.hash === '#cards') {
                    window.scroll({top: document.querySelector('#cards').offsetTop, left: 0, behavior: 'smooth'})
                }
                if (this.$route.hash === '#join') {
                    this.toggleJoinDialog = true
                    window.location.hash = ''
                }
            })
            
        });
        
    },
    
    beforeMount() {
        AuthService.addObserver(this, AuthService.PROFILE_CHANGED, this.setUser); // listen for changes to the user:
    },
    
    computed: {
        
        slidesPerPage() {
            if (this.$breakpoints.xs) return 1
            else if (this.$breakpoints.sm || this.$breakpoints.md) return 2
            else return 3
        },


        mostRecentBooking(){
            var earliest = this.BookingHistory ? this.BookingHistory.sort((a, b)=> {
                return a.BookingDate.date.diff(b.BookingDate.date);
            }) : [];
            return earliest.length > 0 ? earliest[0] : {};
        },

        cinemasByRegion(){
            return [{name: 'Nearby', cinemas: this.cinemasNearBy}].concat(this.regions)
        },

        currentYear() {
            return moment().format('YYYY')
        },

        isUsersBirthday() {
            let now = new Date()
            let today = new Date(`${now.getDate()}/${now.getMonth()}/${now.getFullYear()}`)
            let usersDOB = new Date(this.loggedInUser.DateOfBirth)
            return today.getTime() === usersDOB.getTime()
        },
    },

    watch: {
        '$route' (to, from) {
            if (to.hash == '#join') {
                this.toggleJoinDialog = true
                window.location.hash = ''
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/user/profile.js